import styled from '@emotion/styled';
import { Checkbox, Text } from '@innovationdepartment/proxima-ui';

const CheckboxGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

type GenderCheckboxesProps = {
  options: Array<{ value: string; display: string }>;
  selected: string[];
  onToggle: (value: string) => void;
};

const GenderCheckboxes = ({ options, selected, onToggle }: GenderCheckboxesProps) => (
  <div>
    <Text variant="tag2Semibold" color="neutral70">
      Gender
    </Text>
    <CheckboxGroupWrapper>
      {options.map(option => (
        <Checkbox
          key={option.value}
          controlled
          label={option.display}
          checked={selected.includes(option.value)}
          onChange={() => onToggle(option.value)}
        />
      ))}
    </CheckboxGroupWrapper>
  </div>
);

export default GenderCheckboxes;
